import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogueHandler, RefundTransactionDialogueHandler } from '../types';
import RefundTransactionDialogueContext from './RefundTransactionContext';

const { ConfirmationDialogue } = vp;

type RefundTransactionDialogueProps = {
  handleDialogue: DialogueHandler<RefundTransactionDialogueHandler>;
};

type FC = FunctionComponent<RefundTransactionDialogueProps>;

const RefundTransactionDialogue: FC = ({ handleDialogue }: RefundTransactionDialogueProps) => {
  const { showRefundTransactionConfirmAlert, showRefundTransactionErrorAlert, sendRefundTransactionError } = useContext(
    RefundTransactionDialogueContext,
  );
  const { t } = useTranslation('translations', {
    keyPrefix: 'Transaction.Dialogue.RefundTransaction.RefundTransactionDialogue',
  });
  return useMemo(
    () => (
      <div>
        {/* Transaction Refund Confirmation */}
        <ConfirmationDialogue
          isVisible={showRefundTransactionConfirmAlert}
          title={t('confirmDialogue.title')}
          status="alert"
          subTitle=""
          confirm={{
            label: t('confirmDialogue.yes'),
            action: () => handleDialogue({ type: 'confirm', state: 'success' }),
          }}
          cancel={{
            label: t('confirmDialogue.no'),
            action: () => handleDialogue({ type: 'confirm', state: 'fail' }),
          }}
        />
        {/* Transaction Refund Error */}
        <ConfirmationDialogue
          isVisible={showRefundTransactionErrorAlert}
          title={t('errorDialogue.title')}
          status="error"
          subTitle={`${sendRefundTransactionError}`}
          confirm={{
            label: t('errorDialogue.back'),
            action: () => handleDialogue({ type: 'error', state: 'fail' }),
          }}
        />
      </div>
    ),
    [showRefundTransactionConfirmAlert, showRefundTransactionErrorAlert, sendRefundTransactionError],
  );
};

export default RefundTransactionDialogue;
